import { state } from '@angular/animations';
import { SignalRService } from '../../../../services/signalr.service';

import { Subscription } from 'rxjs/Subscription';
import { CustomNotification } from '../../../../CustomNotification';
import { Component, OnInit, ViewChild, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
// import {  CoBuyerModel, ContractCOBuyer, CoBuyerInfoModel } from '../../../../../../models/CoBuyerModel';


import { ActivatedRoute, Router } from '@angular/router';
import { CountryModel } from '../../../../models/CountryModel';
import { DxGalleryComponent, DxFileUploaderComponent, DxSelectBoxComponent, DxValidatorComponent, DxDataGridComponent } from 'devextreme-angular';


import { DomSanitizer } from '@angular/platform-browser';
import { NgForm } from '@angular/forms';
import { CoBuyerService } from '../../../../services/Co-Buyer.service';
import { SubscriptionService } from '../../../../shared/services/subscription.service';
import { CoBuyerInfoModel, CoBuyerModel, ContractCOBuyer } from '../../../../models/CoBuyerModel';
import { Utilities } from '../../../../Utilities';
import { CommonService } from '../../../../shared/services/common.service';

@Component({
  selector: 'app-co-buyer',
  templateUrl: './co-buyer.component.html',
  styleUrls: ['./co-buyer.component.css']
})
export class CoBuyerComponent implements OnInit, OnDestroy {
  @ViewChild("coBuyerGrid") coBuyerGrid: DxDataGridComponent;

  public CountyList: CountryModel[] = [];
  TitleList = [
    { name: "Mr." },
    { name: "Ms." },
    { name: "Mrs." },
    { name: "Miss" }
  ];
  public CobuyerModel: CoBuyerInfoModel = new CoBuyerInfoModel();
  public CoBuyerModelList: CoBuyerModel = new CoBuyerModel();
  private subscriptions: Subscription[] = [];
  public coBuyerID: number = 0;
  public lotId: Number = 0;
  public ContractID: Number = 0;
  coBuyerPopupVisible = false;
  public Cobuyerheading: any;
  public Cobuyerheadinglist1: any;
  public Cobuyerheadinglist2: any;
  coBuyerMappingPopupVisible = false;
  public CountryList: any[] = [];
  AuthUserObj: any = undefined;
  MsgTitle = '';
  submitted = false;
  public CoBuyerList: any = [];
  constructor(public route: ActivatedRoute,
    public domSanitizer: DomSanitizer,
    public subscriptionService: SubscriptionService,
    public customNotification: CustomNotification,
    public coBuyerService: CoBuyerService,
    public commonService: CommonService) {
    this.AuthUserObj = commonService.AuthUser.getValue();
  }

  ngOnInit() {
    // console.log('co-buyer inititated')
    this.LoadCoBuyerInfo();

  }

  public LoadCoBuyerInfo() {
    this.subscriptions.push(this.subscriptionService.CommunityLotIdContract$.subscribe(x => {
      if (x && x.lotId && x.contractId) {
        this.subscriptions.push(this.coBuyerService.getGetCoBuyerListByCommunityLotId(x.lotId, x.contractId).subscribe(x => {
          // console.log('x', x, this.subscriptions)
          if (x) {
            // this.CoBuyerModelList = x.data && x.data.CoBuyerlstData && x.data.CoBuyerlstData.filter(d => d.CoBuyerName);
            this.CoBuyerModelList = x.data;
            // this.CoBuyerModelList.IsAllowUserToAddEditCoBuyerPermission = x.data.IsAllowUserToAddEditCoBuyerPermission;
            console.log(this.CoBuyerModelList.IsAllowUserToAddEditCoBuyerPermission);
            // if (this.CoBuyerModelList.IsAllowUserToAddEditCoBuyerPermission) {
              this.CoBuyerModelList.CoBuyerlstData = x.data && x.data.CoBuyerlstData && x.data.CoBuyerlstData.filter(d => d.CoBuyerName);
            // } else {
            //   this.CoBuyerModelList = new CoBuyerModel();
            // }
          } else {
            this.CoBuyerModelList = new CoBuyerModel();
          }
        }));
      }
    }))
  }


  onAddEditCobuyerInfo(CoBuyerID) {

    this.coBuyerPopupVisible = true;
    var temp = this.CobuyerModel;
    this.CobuyerModel = new CoBuyerInfoModel();

    this.subscriptions.push(this.subscriptionService.CommunityLotId$.subscribe(lotID => {
      if (lotID) {
        this.subscriptions.push(this.subscriptionService.ContractID$.subscribe(ContractID => {
          if (ContractID) {
            this.subscriptions.push(this.coBuyerService.getCountry().subscribe(x => {
              if (x) {
                this.CountryList = x.data;
              }
              this.CobuyerModel.ContractID = ContractID;
              // console.log(this.CobuyerModel);
              if (CoBuyerID > 0) {
                this.subscriptions.push(this.coBuyerService.getCoBuyerInfoById(CoBuyerID).subscribe(x => {
                  if (x) {
                    this.CobuyerModel = x.data;
                  } else {
                    this.CobuyerModel = new CoBuyerInfoModel();
                  }
                }));
              }

            }));
          }
        }));
      }
    }));
  }

  ClosePopup() {
    this.submitted = false;
    this.coBuyerPopupVisible = false;
    this.CobuyerModel = new CoBuyerInfoModel();
  }


  SaveCoBuyerInfo(ngform, event) {
    this.submitted = true;
    if (this.AuthUserObj === null) {
      this.CobuyerModel.BuyerID = 0;
    }
    else {
      this.CobuyerModel.BuyerID = this.AuthUserObj.BuyerID;
    }

    if (ngform.valid) {

      this.CobuyerModel.CommunityLotID = this.subscriptionService.CommunityLotId$.getValue();
      this.CobuyerModel.ContractID = this.subscriptionService.ContractID$.getValue();

      this.subscriptions.push(this.coBuyerService.saveCoBuyerInfo(this.CobuyerModel).subscribe(x => {

        if (!x.status) {
          this.customNotification.notify(x.message, "", Utilities.error);
        }
        else {
          this.submitted = false;
          this.CobuyerModel.CountryId = 0;
          this.coBuyerPopupVisible = false;
          this.customNotification.notify(x.message, "", Utilities.success);
        }
        this.LoadCoBuyerInfo();
      }));
    }
  }


  ngOnDestroy() {
    this.subscriptions.forEach(x => x.unsubscribe());
  }

  CheckCoBuyerEmailAddress(event: any) {

    this.subscriptions.push(this.coBuyerService.CheckCoBuyerEmailAddress(event.target.value, this.CobuyerModel.CoBuyerID).subscribe(x => {

      this.MsgTitle = "Existing Co-Buyer(s)";
      this.Cobuyerheading = "Co-Buyer(s) having " + this.CobuyerModel.EmailAddress + " email address are already exists in our system and those are shown below.";
      this.Cobuyerheadinglist1 = "If the Co-Buyer which you are trying to assign to this lot is any of below Co-Buyer(s) then please select that Co-Buyer and click on ‘Select’. This will prepopulate that Co-Buyer’s details in ‘Co-Buyer’ form.";
      this.Cobuyerheadinglist2 = "If it is not any of below Co-Buyer(s) then click on ‘Cancel’.";
      if (x.data.length > 0) {
        this.CoBuyerList = x.data;
        this.coBuyerMappingPopupVisible = true;

      }
      else {
        this.CobuyerModel.CopyFromCoBuyerID = 0;
        return
      }

      this.LoadCoBuyerInfo();
    }));

  }
  SaveData(event: any) {
    console.log(event);

    this.CobuyerModel.CopyFromCoBuyerID = event.CoBuyerID;
    this.CobuyerModel.Title = event.Title;
    this.CobuyerModel.FirstName = event.FirstName;
    this.CobuyerModel.MiddleName = event.MiddleName;
    this.CobuyerModel.LastName = event.LastName;
    this.CobuyerModel.Address1 = event.Address1;
    this.CobuyerModel.Address2 = event.Address2;
    this.CobuyerModel.CountryId = event.CountryId;
    this.CobuyerModel.PrimaryStateName = event.PrimaryStateName;
    this.CobuyerModel.PrimaryCityName = event.PrimaryCityName;
    this.CobuyerModel.ZipCode = event.ZipCode;
    this.CobuyerModel.Phone = event.Phone;
    this.CobuyerModel.EmailAddress = event.EmailAddress;
    this.CobuyerModel.IsEmail = event.IsEmail;
    this.CobuyerModel.IsText = event.IsText;
    this.CobuyerModel.IsCall = event.IsCall;
    this.coBuyerMappingPopupVisible = false;
  }
  CloseMappingPopup() {
    this.coBuyerMappingPopupVisible = false;
    this.onAddEditCobuyerInfo(this.CobuyerModel.CoBuyerID);
    // Utilities.confirm("Since you have clicked on ‘Cancel’ button, system will create a new CoBuyer and assign to this lot when you will click on ‘Submit’ button provided in ‘CoBuyer’ form. Are you sure?", "Message")
    // .then((x) => {
    //   if (x) {
    //     Utilities.alert('As you are not changing the Cobuyer. Hence, please revert back the Cobuyer details if you have changed',"Information");
    //     this.coBuyerMappingPopupVisible = false;
    //     this.onAddEditCobuyerInfo(this.CobuyerModel.CoBuyerID);
    //   }
    // });
  }

  public SendMailToCoBuyerCredential(CoBuyerID) {

    this.CobuyerModel = new CoBuyerInfoModel();
    this.CobuyerModel.CommunityLotID = this.subscriptionService.CommunityLotId$.getValue();

    if (this.CobuyerModel.CommunityLotID) {
      if (CoBuyerID > 0) {
        this.subscriptions.push(this.coBuyerService.SendMailToCoBuyerCredential(CoBuyerID, this.CobuyerModel.CommunityLotID, 'BW').subscribe(x => {
          if (x.status) {
            this.customNotification.notify(x.message, "", Utilities.success);
            this.LoadCoBuyerInfo();
          } else {
            this.customNotification.notify(x.message, "", Utilities.error);
          }
        }));
      }
    }
  }
  onRowPrepared(e) {
    // console.log("onRowPrepared",e);
    if (e.rowType === "data") {
      if (e.data.UserId == 0) {
        e.rowElement.style.backgroundColor = "#d9534f";
        e.rowElement.style.color = "white";
        // or
        //e.rowElement.classList.add("ChangeBgColor");
        // to override alternation color
        e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
      }
    }
  }

}





// WEBPACK FOOTER //
// ./src/app/modules/dashboard/dashboard/co-buyer/co-buyer.component.ts